import { colors } from '@giphy/react-giphy-brand'
import { PureComponent } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import withLocationState from 'shared/components/with-location-state'
import { message } from 'shared/redux/message'
import log from 'shared/util/log'
import styled from 'styled-components'
import { Login, TermsOfService } from 'shared/components/form/copy'
import CSRFToken from 'shared/components/form/csrftoken-hoc'
import FacebookButton from 'shared/components/form/facebook-button'
import { FormContainer, Content, CTAButton } from 'shared/components/form/form-components'
import JoinFields from 'shared/components/form/join/fields'
import OptionalFormInputs from 'shared/components/form/join/optional-form-inputs'
import FormHeader from 'shared/components/form/form-header'
import appendNextUrl from 'shared/components/form/get-next-url'
const showNewStuff = false

const sectionMargin = 17

const FacebookButtonWithMargin = styled(FacebookButton)`
    margin-bottom: ${sectionMargin}px;
`

const Placeholder = styled.div`
    margin-bottom: 20px;
`

@CSRFToken
@withRouter
@withLocationState(['formErrors'])
@connect(undefined, { message })
class Form extends PureComponent {
    state = {
        joinEnabled: false,
    }
    componentDidMount() {
        // for testing..
        // const errors = {
        //         username: [
        //             {
        //                 message: 'A user with that username already exists.',
        //                 code: 'unique',
        //             },
        //         ]
        // }
        const { formErrors, message } = this.props
        if (formErrors) {
            log.warn(`form errors:`, formErrors)
            const [firstKey] = Object.keys(formErrors)
            if (firstKey) {
                const [error] = formErrors[firstKey]
                if (error) {
                    message(error.message, 'error')
                }
            }
        }
    }
    areFieldsOkay = () => this.isFormValid && !this.hasDateError
    onValidChange = isFormValid => {
        this.isFormValid = isFormValid
        this.setState({ joinEnabled: this.areFieldsOkay() })
    }
    onDateError = hasDateError => {
        this.hasDateError = hasDateError
        this.setState({ joinEnabled: this.areFieldsOkay() })
    }
    submit = event => {
        event.stopPropagation()
        event.preventDefault()
        if (this.areFieldsOkay()) {
            this.form.submit()
        }
    }
    render() {
        const { joinEnabled } = this.state
        const { csrftoken } = this.props
        return (
            <FormContainer>
                <form method="POST" action={appendNextUrl(`/join`)} onSubmit={this.submit} ref={c => (this.form = c)}>
                    {csrftoken && <input type="hidden" name="csrfmiddlewaretoken" value={csrftoken} />}
                    <Content>
                        <FacebookButtonWithMargin
                            label="Join with Facebook"
                            onClick={() => (location.href = `/login/facebook/${location.search}`)}
                        />
                        <FormHeader>Account Details</FormHeader>
                        <JoinFields onValidChange={this.onValidChange} />
                        {showNewStuff ? <OptionalFormInputs onDateError={this.onDateError} /> : <Placeholder />}
                        <CTAButton
                            color={joinEnabled ? colors.primaryCTA : colors.giphyDarkGrey}
                            disabled={!joinEnabled}
                        >
                            Sign Up
                        </CTAButton>
                        <TermsOfService />
                        <Login />
                    </Content>
                </form>
            </FormContainer>
        )
    }
}

export default Form
